import React from "react"
import './Nav5.css'

function Nav5(){

    return(
        <div className="nav-5 text-danger">
            <button>Suggestions</button>
            <button>Your friends</button>
            <button>Close Friends</button>
        </div>
    )
}

export default Nav5